"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var AnimationKeyFrame_1 = require("./AnimationKeyFrame");
var AbstractAnimationValue = (function (_super) {
    tslib_1.__extends(AbstractAnimationValue, _super);
    function AbstractAnimationValue(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(AbstractAnimationValue.prototype, "value", {
        get: function () {
            return this._rawData.k;
        },
        set: function (value) {
            this._rawData.k = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractAnimationValue.prototype, "index", {
        get: function () {
            return this._rawData.ix;
        },
        set: function (index) {
            this._rawData.ix = index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractAnimationValue.prototype, "animated", {
        get: function () {
            if (this._rawData.a) {
                return this._rawData.a === 1;
            }
            return undefined;
        },
        set: function (animated) {
            this._rawData.a = (animated ? 1 : 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractAnimationValue.prototype, "keyframes", {
        get: function () {
            var _this = this;
            if (this._rawData.k !== undefined) {
                return this._rawData.k.map(function (rawKeyFrame) {
                    return new AnimationKeyFrame_1.AnimationOffsetKeyframe(rawKeyFrame, _this._rawDataVer);
                });
            }
            else {
                return [];
            }
        },
        enumerable: true,
        configurable: true
    });
    return AbstractAnimationValue;
}(AnimationObject_1.AnimationObject));
exports.AbstractAnimationValue = AbstractAnimationValue;
//# sourceMappingURL=AbstractAnimationValue.js.map